import { render, staticRenderFns } from "./UsersPrivilegeDoctorNotes.vue?vue&type=template&id=684a1123&scoped=true&"
import script from "./UsersPrivilegeDoctorNotes.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeDoctorNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a1123",
  null
  
)

export default component.exports